<div>
    <div class="notification-icon-wrapper" [class.switch]="!isBell()">
        <img
            class="notification-icon"
            [src]="getNotificationOnImgUrl()"
            *ngIf="(isAllowedClubNotifications$ | async)"
            (click)="setChatNotification(true)"
        />
        <img
            class="notification-icon"
            [src]="getNotificationOffImgUrl()"
            *ngIf="(isAllowedClubNotifications$ | async) === false"
            (click)="setChatNotification(false)"
        />
    </div>
    <label *ngIf="label">Notifications</label>
</div>
